import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const UnifiedTeamsListView = lazy(() => import('./components/views/UnifiedTeamsListView'));

const UnifiedTeamDetailView = lazy(() => import('./components/views/UnifiedTeamDetailView'));

const SchedulingWorkspace = lazy(() => import('./components/views/SchedulingWorkspace'));

const teamsRoutes: FuseRouteItemType[] = [
	{ path: '/staff-shifts', element: <SchedulingWorkspace /> },
	{
		path: 'teams',
		children: [
			{
				index: true,
				element: <UnifiedTeamsListView />
			},
			{
				path: ':teamId',
				element: <UnifiedTeamDetailView />
			}
		]
	}
];

export default teamsRoutes;
